<template>
  <div>
    <myheader></myheader>
    <van-image :src="require('../assets/img/about_banner.png')"/>
    <h1 style="font-size: 1.2rem; color: #333333; font-weight: normal; text-align: center;">员工一览</h1>
    <hr width="10%" style="border: 1px solid #000;">
    <van-grid :gutter="10" :column-num="2">
      <van-grid-item v-for="(item, index) in list" :key="index" >
        <van-image :src="item.image ? item.image.url : ''" />
        <h4 style="font-weight: normal; margin: 5px;">{{ item.name }}-{{ item.position }}</h4>
      </van-grid-item>
    </van-grid>
    <myfooter></myfooter>
  </div>
</template>

<script>
import {Field, Button, Cell, CellGroup, Toast, Swipe, SwipeItem, Image, Row, Col, Grid, GridItem} from 'vant'
import { getStaffList } from '@/api'

export default {
  name: 'Staffs',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Image.name]: Image,
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button,
  },
  data() {
    return {
      list: []
    }
  },
  methods: {
    getStaffList(){
      getStaffList().then(res => {
        this.list = res.data
      })
    }
  },
  mounted() {
    this.getStaffList()
  }
}
</script>

<style scoped>
.about_content {
  padding: 1rem 1.5rem 2.1rem;
  font-size: 0.78rem;
  font-weight: normal;
  color: #666666;
  line-height: 1.2rem;
}
</style>
